import type FindMeetingTimesResponse from 'owa-calendar-scheduling-service/lib/schema/FindMeetingTimesResponse';
import { action } from 'satcheljs';
import type { OwaDate } from 'owa-datetime';
import type { TimeSuggestionsRequestState } from '../store/schema/TimeSuggestionsRequestState';
import type CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';
import type TimeSuggestionsViewState from '../store/schema/TimeSuggestionsViewState';

export const setPreviousDate = action(
    'setPreviousDate',
    (prevStart: OwaDate, viewStateId: string | null) => ({
        prevStart,
        viewStateId,
    })
);

export const setPreviousDurationInMinutes = action(
    'setPreviousDurationInMinutes',
    (durationInMinutes: number, viewStateId: string | null) => ({ durationInMinutes, viewStateId })
);

export const updateTimeSuggestions = action(
    'updateTimeSuggestions',
    (timeSuggestions: FindMeetingTimesResponse, viewStateId: string | null) => ({
        timeSuggestions,
        viewStateId,
    })
);

export const setTimeSuggestionsRequestState = action(
    'setTimeSuggestionsRequestState',
    (timeSuggestionsRequestState: TimeSuggestionsRequestState, viewStateId: string | null) => ({
        timeSuggestionsRequestState,
        viewStateId,
    })
);

export const setLastFindMeetingTimesRequestId = action(
    'setLastFindMeetingTimesRequestId',
    (lastFindMeetingTimesRequestId: string, viewStateId: string | null) => ({
        lastFindMeetingTimesRequestId,
        viewStateId,
    })
);

export const setLastFindMeetingTimesRequestDate = action(
    'setLastFindMeetingTimesRequestDate',
    (lastFindMeetingTimesRequestDate: Date, viewStateId: string | null) => ({
        lastFindMeetingTimesRequestDate,
        viewStateId,
    })
);

export const showSearchCriteriaDialog = action(
    'showSearchCriteriaDialog',
    (event: CalendarEvent, viewStateId: string | null) => ({ event, viewStateId })
);

export const initTimeSuggestionsStore = action(
    'initTimeSuggestionsStore',
    (timeSuggestionsViewState: TimeSuggestionsViewState, viewStateId: string | null) => ({
        timeSuggestionsViewState,
        viewStateId,
    })
);
